import React, { useState, useEffect } from 'react';
import { NoBuilding } from '../../common';

import './WaterTable.css';
import '../../styles/billingPageStyles.css'

const convertRound = (value) => {
    return Math.round(value);
};

const convertString2Int = (string) => {
    return parseInt(String(string).replace(/,/g, ''), 10) || 0
};

const convertInt2String = (num) => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
};

const priceUnitCutting = (value) => {
    return Math.floor(value / 10) * 10;
};

const safeValue = (value) => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
        return 0;
    }
    return value;
};

const WaterTable = ({ hasBuilding, roomInfo, setRoomInfo }) => {
    const [displayValues, setDisplayValues] = useState({})

    useEffect(() => {
        const initialDisplayValues = roomInfo.reduce((acc, room) => {
            acc[room.roomId] = {
                roomPrevWaterUsed: convertInt2String(room.roomPrevWaterUsed),
                roomCurrWaterUsed: convertInt2String(room.roomCurrWaterUsed),
                roomWaterChangePrice: convertInt2String(room.roomWaterChangePrice),
                memoWater: room.memoWater || ""
            };
            return acc;
        },{});
        setDisplayValues(initialDisplayValues);
    }, [roomInfo]);

    const handleChange = (id, className, e) => {
        const inputValue = e.target.value; // 쉼표 제거
        if (/^-?\d*$/.test(inputValue)) { // 맨 앞에는 -를 허용하고 그 뒤로는 숫자만 허용
            setDisplayValues(prevValues => ({
                ...prevValues,
                [id]: {
                    ...prevValues[id],
                    [className]: inputValue
                }
            }))
        }
    };

    const handleTextChange = (id, className, e) => {
        const inputValue = e.target.value;
        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: inputValue
            }
        }))
    };

    const handleBlur = (id, className, e) => {
        const inputValue = convertString2Int(e.target.value);
        setRoomInfo(id, className, inputValue);

        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: convertInt2String(inputValue)
            }
        }));
    };

    const handleTextBlur = (id, className, e) => {
        const inputValue = e.target.value;
        setRoomInfo(id, className, inputValue);

        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: inputValue
            }
        }));
    };

    const handleFocus = (id, className, e) => {
        const inputValue = convertString2Int(e.target.value)
        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: {
                ...prevValues[id],
                [className]: inputValue === 0 ? '' : inputValue
            }
        }));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur(); // 엔터 키를 누르면 포커스를 잃도록 처리
        }
    };

    return (
        <table className="table">
            <thead>
                <tr>
                    <th className='whiteTable waterTableColumn1 tableHead'>호실명</th>
                    <th className='whiteTable waterTableColumn2 tableHead'>임차사명</th>
                    <th className='whiteTable waterTableColumn3 tableHead'>전용면적</th>
                    <th className='whiteTable waterTableColumn4 tableHead'>임대비율</th>
                    <th className='grayTable waterTableColumn5 tableHead'>수도계량기</th>
                    <th className='grayTable waterTableColumn6 tableHead'>전월사용량</th>
                    <th className='grayTable waterTableColumn7 tableHead'>현월사용량</th>
                    <th className='redTable waterTableColumn8 tableHead'>사용량</th>
                    <th className='orangeTable waterTableColumn9 tableHead'>사용량 금액</th>
                    <th className='orangeTable waterTableColumn10 tableHead'>공용수도금액</th>
                    <th className='grayTable waterTableColumn11 tableHead'>총 합계</th>
                    <th className='redTable waterTableColumn12 tableHead'>금액조정</th>
                    <th className='blueTable blueFont waterTableColumn13'>청구 금액
                        <br/>
                        <span className="tableAdditional">
                            (원단위 절삭)
                        </span>
                    </th>
                    <th className='grayTable elecTableColumn14 tableHead'>비고</th>
                </tr>
            </thead>
            <tbody>
                {hasBuilding === false ? (
                    <tr>
                        <td colSpan="14">
                            <NoBuilding />
                        </td>
                    </tr>
                ) : (
                    roomInfo.filter(room => room.roomStatus === "CONTRACT").length === 0 ? (
                        <tr>
                            <td colSpan="14">
                                <NoBuilding message="호실 상태가 입실인 호실을 추가해주세요!" />
                            </td>
                        </tr>
                    ) : (
                        roomInfo
                        .filter(room => room.roomStatus === "CONTRACT")
                        .concat(roomInfo.filter(room => room.roomStatus !== "CONTRACT"))
                        .map(room => {
                            const isError = room.roomCurrWaterUsed < room.roomPrevWaterUsed;

                            return (
                                <tr key={room.roomId}>
                                    <td className='whiteTable waterTableColumn1 blueFont boldFont tableChild'>{room.roomName}</td>
                                    <td className={`whiteTable waterTableColumn2 tableChild ${room.roomStatus !== "CONTRACT" ? "noCustomerStyle customerStyle" : "customerStyle"}`}>{room.roomStatus === "CONTRACT" ? room.roomCustomerName : room.roomStatus === "EMPTY" ? "공실" : "공용"}</td>
                                    <td className='whiteTable waterTableColumn3 tableChild'>{convertInt2String(room.roomPrivateArea || 0)}m²</td>
                                    <td className='whiteTable waterTableColumn4 tableChild'>{(room.privateAreaRatio * 100).toFixed(1)}%</td>
                                    <td className='grayTable waterTableColumn5 tablePrice tableChild'>{room.roomWaterMeter}</td>
                                    <td className='grayTable waterTableColumn6'>
                                        <input
                                            className={`tableInputBoxInput ${room.roomStatus === "CONTRACT" ? 'contract-style' : 'non-contract-style'} ${isError ? ' error-border' : ''}`}
                                            type="text"
                                            value={displayValues[room.roomId]?.roomPrevWaterUsed || ''}
                                            placeholder='0'
                                            onChange={(e) => handleChange(room.roomId, 'roomPrevWaterUsed', e)}
                                            onBlur={(e) => handleBlur(room.roomId, 'roomPrevWaterUsed', e)}
                                            onFocus={(e) => handleFocus(room.roomId, 'roomPrevWaterUsed', e)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </td>
                                    <td className='grayTable waterTableColumn7'>
                                        <input
                                            className={`tableInputBoxInput ${room.roomStatus === "CONTRACT" ? 'contract-style' : 'non-contract-style'} ${isError ? ' error-border' : ''}`}
                                            type="text"
                                            value={displayValues[room.roomId]?.roomCurrWaterUsed || ''}
                                            placeholder='0'
                                            onChange={(e) => handleChange(room.roomId, 'roomCurrWaterUsed', e)}
                                            onBlur={(e) => handleBlur(room.roomId, 'roomCurrWaterUsed', e)}
                                            onFocus={(e) => handleFocus(room.roomId, 'roomCurrWaterUsed', e)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </td>
                                    <td className='redTable waterTableColumn8 boldFont tableChild'>{convertInt2String(room.roomWaterUsed)}</td>
                                    <td className='orangeTable waterTableColumn9 tablePrice boldFont tableChild'>{convertInt2String(room.roomWaterPrice)}원</td>
                                    <td className='orangeTable waterTableColumn10 tablePrice boldFont tableChild'>{convertInt2String(room.roomCommonWaterPrice)}원</td>
                                    <td className='grayTable waterTableColumn11 tablePrice tableChild'>{convertInt2String(room.totalWaterAndCommonWaterPrice)}원</td>
                                    <td className='redTable waterTableColumn12'>
                                        <input
                                            className={`tableInputBoxInput ${room.roomStatus === "CONTRACT" ? 'contract-style' : 'non-contract-style'}`}
                                            type="text"
                                            value={displayValues[room.roomId]?.roomWaterChangePrice || ''}
                                            placeholder='0'
                                            onChange={(e) => handleChange(room.roomId, 'roomWaterChangePrice', e)}
                                            onBlur={(e) => handleBlur(room.roomId, 'roomWaterChangePrice', e)}
                                            onFocus={(e) => handleFocus(room.roomId, 'roomWaterChangePrice', e)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </td>
                                    <td className='blueTable blueFont waterTableColumn13 tablePrice boldFont tableChild'>{convertInt2String(room.totalPrice)}원</td>
                                    <td className='grayTable waterTableColumn14 tableHead'>
                                        <input
                                            className={"tableInputBoxMemo"}
                                            type="text"
                                            value={displayValues[room.roomId]?.memoWater || ''}
                                            placeholder="특이사항 메모"
                                            onChange={(e) => handleTextChange(room.roomId, 'memoWater', e)}
                                            onBlur={(e) => handleTextBlur(room.roomId, "memoWater", e)}
                                            onKeyPress={handleKeyPress}
                                        ></input>
                                    </td>
                                </tr>
                            );
                        })
                    )
                )}
            </tbody>
        </table>
    );
}

export default WaterTable;